import { UISref, useRouter } from "@uirouter/react";
import { noop } from "lodash";
import { useForm } from "react-hook-form";
import { EditableField } from "../../components/forms/field";
import { useAppLoader } from "../../components/loader/app-loader-hook";
import { AuthDTO } from "../../store/auth/models/dto";
import { AuthService } from "../../store/auth/service";
import { useYupValidationResolver } from "../../utils/utils";
import { Form } from "./base";

type RequestDTO = AuthDTO.Requests.ForgotPassword.T;
const { useFields, defaults } = AuthDTO.Requests.ForgotPassword;

export const ForgotPasswordPage = () => {
  const { labels, validation } = useFields();
  const resolver = useYupValidationResolver(validation);
  const loader = useAppLoader();
  const router = useRouter();
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<RequestDTO>({
    defaultValues: defaults,
    resolver,
  });

  return (
    <Form.Form
      onSubmit={handleSubmit((data) => {
        loader(
          AuthService.forgotPassword(data)
            .then(() => router.stateService.go("^.login"))
            .catch(noop) // TODO log such error maybe
        );
      })}
    >
      <h1 className="h1">Reset Password</h1>
      <Form.Smaller>
        Type in your Email and we will send you a recovery letter
      </Form.Smaller>
      <EditableField editing control={control} name="emailAddress">
        <Form.TextField
          fullWidth
          type="email"
          label={labels.emailAddress}
          error={!!errors.emailAddress}
          helperText={errors.emailAddress?.message}
        />
      </EditableField>
      <Form.Login>Submit</Form.Login>
      <Form.Smaller>
        Remembered your account?{" "}
        <UISref to="^.login">
          <a>Sign In!</a>
        </UISref>
      </Form.Smaller>
    </Form.Form>
  );
};
